import * as yup from 'yup';
import { addOrderAttachmentFormFields } from '../../fields/formFields';

export const addOrderAttachmentFormSchema = yup.object({
  [addOrderAttachmentFormFields.orderAttachmentType]: yup.number().positive().required('Attachment type is required'),
  [addOrderAttachmentFormFields.documentLink]: yup.string().required('Document Link is required').trim(),
});
